export default __webpack_public_path__ + "static/media/GitHub.79b345fa.svg";